export default __webpack_public_path__ + "static/media/img_chart_grade_A-.e59f9cb022aa8c6b180ae2b10f67162d.svg";